import React, { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import QuickLinks from './Components/QuickLinks';
import { useSelector } from 'react-redux';
import BentoBoxGrid from '../../v2/MUI_custom_component/Bento/BentoBoxGrid';
import BentoItem from '../../v2/MUI_custom_component/Bento/BentoItem';
import { decodeToken } from '../../utils/settings';
import DashboardCard from './Components/DashboardCard';
import { getHomepageData } from './Action';
import { toast } from 'react-toastify';
import { addressDetailAction } from '../../v2/Address/APIs/action';
import DeliveryLocationCard from '../../v2/Address/Screens/DeliveryLocationCard';
import Entity from '../Common/Entity';
import { getCompanySuppliersAction } from '../../v2/BCMOrder/Action';

const HomePage = () => {
  const { loginUser, is_PWA } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
      is_PWA: state.loginReducer.is_PWA,
    };
  });

  const [addressDetails, setAddressDetails] = useState(null);
  const [tokenData, setTokenData] = useState({});
  const [companyEsiId, setCompanyEsiId] = useState(null);
  const getTokenData = async () => {
    const decoded = await decodeToken();
    setTokenData(decoded);
  };
  useEffect(() => {
    getTokenData();
  }, []);
  const allowedKeys = tokenData?.quicklink_config ?? [];

  const mockData = {
    inventoryLeft: 50,
    expiryDays: 10,
    progress: {
      title: 'Gold Club',
      subtitle: 'Current Level',
      logo: 'https://d2djimvzddgguw.cloudfront.net/humbee-insurance-card/digit_logo.png',
      slider_info: {
        current_value: 150,
        club_max_value: 300,
        uom: 'Ton',
      },
    },
    salesOptions: ['50-99 kg', '100-299 kg', '300-499 kg'],
  };
  const [homeData, setHomeData] = useState({});
  const [loading, setLoading] = useState(false);
  const user_id = loginUser ? loginUser.user_id : null;
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const getHomeData = async () => {
    setLoading(true);
    const { error, message, data } = await getHomepageData(user_id);
    setLoading(false);
    if (!error) {
      setHomeData(data);
    } else {
      toast.error(message);
    }
  };

  //Suppliers is called only for Dalmia (PWA) as at the moment Address feature is not clear for Entity in Humbee System
  const getSuppliers = async () => {
    const { error, data, message } = await getCompanySuppliersAction();
   
    if (!error) {
      const company_esi_id = data[0].suppliers_list[0]?.entity_info[0]?.esi_id;
      setCompanyEsiId(company_esi_id);
    }
  };

  const fetchAddressDetails = async (company_esi_id) => {
    try {
      const response = await addressDetailAction(company_esi_id);

      if (!response.error && response.data) {
        setAddressDetails(response.data[0]);
      }
    } catch (error) {
      console.error('Error fetching address details:', error);
    }
  };
  useEffect(() => {
    if (is_PWA) {
      getSuppliers();
    }
  }, [is_PWA]);

  useEffect(() => {
    if (companyEsiId) {
      fetchAddressDetails(companyEsiId);
    }
  }, [companyEsiId]);

  useEffect(() => {
    getHomeData();
  }, [loginUser]);
  const { banner } = homeData;
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200, // for large laptops
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900, // tablets
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600, // mobiles
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Box
      sx={{ px: { xs: 2, lg: 2 } }}
      pb={8}
    >
      {/* <Typography variant="h1" sx={{ mb: 2 }}>
        {loginUser &&  `Hi ${loginUser.first_name} ${loginUser.last_name}` }
      </Typography> */}
      <Box sx={{ width: '100%', mb: 2, display: 'flex', pt: { xs: 1, md: 0 } }}>
        <Box sx={{ width: '100%' }}>
          <Slider {...sliderSettings}>
            {banner?.sliders &&
              banner?.sliders.map((slider, idx) => (
                <Box
                  key={idx}
                  sx={{ px: { xs: 0, md: 1 } }}
                >
                  <Box
                    component='img'
                    src={slider?.src}
                    alt={`Slider ${idx + 1}`}
                    sx={{
                      width: '100%',
                      borderRadius: 2,
                      objectFit: 'cover',
                      aspectRatio: '179/104',
                    }}
                  />
                </Box>
              ))}
          </Slider>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          width: '100%',
          mb: 2,
          '& .MuiCard-root': {
            mx: 0, // Override the mx: 'auto' from DeliveryLocationCard
            ml: 0, // Ensure left margin is 0
          },
        }}
      >
        {/* Delivery Location Card */}
        {loginUser && (
          <>
            {is_PWA &&
            (!addressDetails || addressDetails?.length !== 0) ? null : (
              <DeliveryLocationCard
                addressDetails={addressDetails}
                fetchAddressDetails={fetchAddressDetails}
                isPwa={is_PWA}
                showMobileSizedCard={true}
              />
            )}
          </>
        )}
      </Box>
      <BentoBoxGrid
        rows={{ md: 3 }}
        column={12}
        gap={2}
      >
        {isMobile && loginUser && (
          <BentoItem
            colSpan={{ xs: 12, md: 4 }}
            rowSpan={{ xs: 1, md: 2 }}
          >
            <QuickLinks allowedKeys={allowedKeys} />
          </BentoItem>
        )}
        {/* <BentoItem colSpan={{ xs: 12, md: 8 }} rowSpan={{ xs: 1, md: 3 }}>
          <DashboardCard data={mockData} />
        </BentoItem> */}
        <BentoItem
          colSpan={{ xs: 12, md: 4 }}
          rowSpan={{ xs: 1, md: 1 }}
        >
          <Box sx={{ width: '100%' }}>
            <Typography
              variant='title'
              sx={{ color: '#666', mb: 2 }}
            >
              <Typography
                component='span'
                variant='title'
                sx={{ color: '#FFA525' }}
              >
                Goodness
              </Typography>{' '}
              is our only Business
            </Typography>
            <Typography
              variant='labelD'
              sx={{ color: '#8C8C8C' }}
            >
              World’s #1 business community welfare platform
            </Typography>
          </Box>
        </BentoItem>
      </BentoBoxGrid>
    </Box>
  );
};

export default HomePage;
